/*
 * @Descripttion:
 * @version:
 * @Author: tangshuo
 * @Date: 2022-10-17 10:59:13
 * @LastEditors: tangshuo
 * @LastEditTime: 2023-04-14 18:06:03
 */
import { Modal } from '@firesoon/antd';
import { ModalFuncProps, ModalProps } from '@firesoon/antd/lib/modal';
import React from 'react';
import './index.less';

interface props extends ModalProps {
  info?: ModalFuncProps;
  success?: ModalFuncProps;
  error?: ModalFuncProps;
  warning?: ModalFuncProps;
  confirm?: ModalFuncProps;
  children?: React.ReactNode;
}

const { info, success, error, warning, confirm, destroyAll } = Modal;

const Index = ({ wrapClassName, transitionName, children, okText, cancelText, ...rest }: props) => {
  return (
    <Modal
      wrapClassName={`${wrapClassName} fs-modal`}
      transitionName={transitionName ?? 'fade'}
      maskClosable={false}
      okText={okText ?? '确认'}
      cancelText={cancelText ?? '取消'}
      {...rest}
    >
      {children}
    </Modal>
  );
};

const reloadActionFc = (action, { className, okText, cancelText, ...rest }: ModalFuncProps) => {
  return action({
    className: `${className ?? ''} fs-confirm-modal`,
    okText: okText ?? '确认',
    cancelText: cancelText ?? '取消',
    autoFocusButton: null,
    ...rest,
  });
};

Index.info = function (props: ModalFuncProps) {
  return reloadActionFc(info, props);
};

Index.success = function (props: ModalFuncProps) {
  return reloadActionFc(success, props);
};

Index.error = function (props: ModalFuncProps) {
  return reloadActionFc(error, props);
};

Index.warning = function (props: ModalFuncProps) {
  return reloadActionFc(warning, props);
};

Index.confirm = function (props: ModalFuncProps) {
  return reloadActionFc(confirm, props);
};

Index.destroyAll = function () {
  return destroyAll();
};

export default Index;
